export const filterHandler = (optionFilters, source) => {
  if(source.isValid) {
    if((optionFilters.covered && source.isCovered) || (optionFilters.notCovered && !source.isCovered)) {
      return true;
    }
  }
  if (!source.isValid && optionFilters.invalid) {
    return true;
  }
  return false;
};

export const storyFilterHandler = (optionFilters, story) => {
  const {
    matchingProfileIds,
    nonMatchingProfileIds
  } = story;
  let { isValid } = story;
  if (typeof isValid === 'undefined') {
    isValid = matchingProfileIds.length > 0 || nonMatchingProfileIds.length > 0;
  }
  if(isValid) {
    const covered = optionFilters.covered && matchingProfileIds.length > 0;
    const notCovered = optionFilters.notCovered
      && matchingProfileIds.length === 0
      && nonMatchingProfileIds.length > 0;
    if(covered || notCovered) {
      return true;
    }
  }
  if (!isValid && optionFilters.invalid) {
    return true;
  }
  return false;
};
